import { useEffect, useState } from "react";
import '../LoginScreen/Onboarding/Onboarding.css'
import { useDispatch, useSelector } from "react-redux";
import { selectAppAuth } from "../../services/auth/authSlice";
import { checkUserFields, selectUserInfo, updateUserData, updateUserField } from "../../features/User/userSlice";
import { selectCurrentLang, selectTranslations } from "../../services/i18n/i18nSlice";

import {TitleH1} from "../../components/TitleH1";
import {Text} from "../../components/Text";
import {Button} from "../../components/Button";
import Form from 'react-bootstrap/Form';
import Select from 'react-select'
import { toast } from "react-toastify";

import degree_img from '../../assets/images/exams/degree.svg'
import chrome_img from '../../assets/images/chrome.svg'
import alert_img from '../../assets/images/exams/warning-alert.svg'
import pc_img from '../../assets/images/exams/computer-pc.svg'
import proctoring_img from '../../assets/images/exams/proctoring.svg'
import user_img from '../../assets/images/exams/user.svg'

import { selectAppPersonalizations } from "../../services/utils/appInfoSlice";
import { API_URL, BASE_URL, DEFAULT_FIELDS, WEB_PATH } from "../../config/constants";
import FloatingLabel from "react-bootstrap/esm/FloatingLabel";
import { useNavigate } from "react-router-dom";
import CustomDatePicker from "../../components/_forms/CustomDatePicker";
import { SelectOption } from "../../components/_forms/CustomSelectOption";
import { CustomSelectValueContainer } from "../../components/_forms/CustomSelectValueContainer";
import { setNavbarHide, setNavbarHideMobile } from "../../services/global/globalSlice";

export default function SelfAssessmentTftLandingScreen(props) {

    const getUserDefaultData = () => {
        return userInfo?.user_fields?.filter((f)=>{
            if(f.field_level === 0){
                if(DEFAULT_FIELDS.includes(f.field_id))
                    if(userInfo?.user_data[f.field_id])
                        return f
                else{
                    if(userInfo?.user_data?.extra_fields.find(e => e.field_id === f.field_id)?.values)
                        return f
                } 
            } 
        }) || []
    }

    const [currentStep, setCurrentStep] = useState(0)
    const personalizations = useSelector(selectAppPersonalizations)
    const userAuth = useSelector(selectAppAuth)
    const userInfo = useSelector(selectUserInfo)
    const t = useSelector(selectTranslations);
    const missingFields = useSelector(checkUserFields)
    const currentLang = useSelector(selectCurrentLang)
    const dispatch = useDispatch()

    let navigate = useNavigate()

    const [hasSeenPrivacy, setHasSeenPrivacy] = useState(false);
    const [validatedForm, setValidatedForm] = useState(false);
    
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        setValidatedForm(true);
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            let user_data = []
            let field_id = null
            userInfo?.user_fields?.forEach((f)=>{
                field_id = f.field_id
                if(f.field_level === 0 || f.field_level === 1){
                    if(DEFAULT_FIELDS.includes(field_id))
                        user_data.push({field_id: field_id, field_values:userInfo?.user_data[field_id]})
                    else{
                        const field_value = userInfo?.user_data?.extra_fields?.find(e => e.field_id === field_id)?.values
                        if(field_value)
                            user_data.push({field_id: field_id, field_values:f.field_type === "datetime" ? `${new Date(field_value).toISOString().substring(0,19)}+00:00` : field_value})
                    } 
                }
            })
            dispatch(updateUserData({user_data: user_data})).then(data => {
                if (data.payload) {
                    setCurrentStep(currentStep+1)
                } else {
                    toast.error(t.error.error_saving)
                }
            })    
            event.preventDefault();
            event.stopPropagation();
        }
        
    };

    const handleEndPrivacyDocument = (p) => {
        if(p.currentPage === p.doc?._pdfInfo?.numPages -1)
            setHasSeenPrivacy(true)
    }

    const handleConfirmLegal = () => {
        const user_data = [{ "field_id" : "legal_checks", 
            "field_values": {
                "internal_legal_check" : true,
                "external_legal_check" : true
            }
        }]
        dispatch(updateUserData({user_data: user_data})).then((data)=>{
            if (data.payload) {
                setCurrentStep(currentStep+1)
            } else {
                toast.error(t.error.error_saving)
            }
        })
    }

    const normalizeUrl = (url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return `${window.location.protocol}//${url}`
        }
        return url
    }

    const getRedirectUrl = () => {
        if(personalizations?.tenant_settings?.url_webapp){
            return personalizations.tenant_settings.url_webapp
        } else {
            return `${window.location.origin}` 
        }
    }


    const copyUrl = () => {
        const url = new URL(`${normalizeUrl(getRedirectUrl())}${WEB_PATH}/login/`);
        navigator.clipboard.writeText(url);
        toast.success("Indirizzo copiato")
    }
    
    useEffect(()=>{
        setCurrentStep(0)
        dispatch(setNavbarHideMobile(true))
        dispatch(setNavbarHide(true))
    }, [])
    
    return(
        <div id="onboardingScreen">
            {
                currentStep === 0 ?
                    <div className=" mt-4 ">
                        <TitleH1 className="text-start text-lg-center">{t.self_assessment_test.title}</TitleH1>
                        <Text>{t.self_assessment_test.text}</Text>
                        <small className="mt-5 d-block">{t.self_assessment_test.before_begin}</small>
                        <ul className="next_steps no_link fade-in-animation">
                            <li className="first">
                                <img src={degree_img} />
                                <p className="mb-0" dangerouslySetInnerHTML={{__html: t.self_assessment_test.landing_steps.step_1}} />
                            </li>
                            <li>
                                <img src={alert_img} />
                                <p className="mb-0" dangerouslySetInnerHTML={{__html: t.self_assessment_test.landing_steps.step_2}} />
                            </li>
                        </ul>
                        <div className="bottom_controller">
                            <Button className="w-100 mx-auto" onClick={()=>{setCurrentStep(currentStep+1)}}>
                                {t.self_assessment_test.go_to_instructions}
                            </Button>
                        </div>
                    </div>
                : ""
            }
            {
                currentStep === 1 ?
                    <div className=" mt-4 ">
                        <TitleH1 className="text-start text-lg-center">{t.self_assessment_test.title}</TitleH1>
                        <Text>{t.self_assessment_test.text}</Text>
                        <small className="mt-5 d-block">{t.self_assessment_test.instructions}</small>
                        <ul className="next_steps no_link fade-in-animation">
                            <li className="first align-items-start">
                                <img src={pc_img} style={{width:'30px'}} />
                                <p className="mb-0" dangerouslySetInnerHTML={{__html: t.self_assessment_test.landing_steps.step_3}} />
                            </li>
                            <li className="align-items-start">
                                <img src={chrome_img} style={{width:'30px'}} />
                                <p className="mb-0" dangerouslySetInnerHTML={{__html: t.self_assessment_test.landing_steps.step_6}} />
                            </li>
                            <li className="align-items-start">
                                <img src={proctoring_img} style={{width:'30px'}} />
                                <p className="mb-0" dangerouslySetInnerHTML={{__html: t.self_assessment_test.landing_steps.step_4}} />
                            </li>
                            <li className="align-items-start">
                                <img src={user_img} style={{width:'30px'}} />
                                <p className="mb-0" dangerouslySetInnerHTML={{__html: t.self_assessment_test.landing_steps.step_5}} />
                            </li>
                        </ul>
                        <div className="bottom_controller">
                            <Button className="w-100 mx-auto" onClick={()=>{setCurrentStep(currentStep+1)}}>
                                {t.self_assessment_test.go_to_data}
                            </Button>
                        </div>
                    </div>
                : ""
            }
            {
                currentStep === 2 ?
                    <div className=" mt-4">
                        <TitleH1 className="text-left text-lg-center">{t.self_assessment_test.confirm_data}</TitleH1>
                        <Text className="text-left text-lg-center">{t.self_assessment_test.confirm_data_text}</Text>
                        <Form noValidate validated={validatedForm} onSubmit={handleSubmit} className="w-100">
                        <Form.Group controlId={'email'}  className="mb-3">
                            <FloatingLabel
                                controlId={'email'}
                                label={'E-Mail'}
                                key={'email'}
                            >
                                <Form.Control required type={'email'}  value={userInfo?.user_data?.email || ''} disabled={true}/>
                            </FloatingLabel>
                        </Form.Group>
                        {
                            userInfo?.user_fields?.map((f)=>{
                                const field_id = f.field_id
                                if(DEFAULT_FIELDS.includes(field_id) && f.field_level === 0){
                                    return(
                                        <Form.Group controlId={field_id} key={field_id} className="mb-3">
                                            <FloatingLabel
                                                controlId={field_id}
                                                label={(f.field_names[currentLang] || f.field_names.it)}
                                                key={field_id}
                                            >
                                                <Form.Control required type={f.field_type} placeholder={(f.field_names[currentLang] || f.field_names.it)} value={userInfo?.user_data[field_id] || ''} onChange={(e)=>dispatch(updateUserField({value: e.target.value, field_id: field_id, type:'default'}))}/>
                                                <Form.Control.Feedback type="invalid" >
                                                    <small className="text-danger">{t.forms.invalid_input}</small>
                                                </Form.Control.Feedback>
                                            </FloatingLabel>
                                        </Form.Group>
                                    )
                                } else if(f.field_level === 0 || f.field_level === 1) {
                                    return(
                                        <Form.Group controlId={field_id} key={field_id} className="mb-3">
                                            {
                                                f.field_type === 'datetime'?
                                                <FloatingLabel
                                                    controlId={field_id}
                                                    label={(f.field_names[currentLang] || f.field_names.it)}
                                                    key={field_id}
                                                >
                                                    <Form.Control required={true} type={'date'} value={userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values?.substring(0,10) || ''}  onChange={(e)=>dispatch(updateUserField({value: e.target.value, field_id: field_id, type:'extra'}))}/>
                                                    <Form.Control.Feedback type="invalid">
                                                        <small className="text-danger">{t.forms.invalid_input}</small>
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                                : ""
                                            }
                                            {
                                                f.field_type === 'text'?
                                                <FloatingLabel
                                                    controlId={field_id}
                                                    label={(f.field_names[currentLang] || f.field_names.it)}
                                                    key={field_id}
                                                >
                                                    <Form.Control required={true} type={f.field_type} placeholder={(f.field_names[currentLang] || f.field_names.it)} value={userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values || ''} onChange={(e)=>dispatch(updateUserField({value: e.target.value, field_id: field_id, type:'extra'}))}/>
                                                    <Form.Control.Feedback type="invalid">
                                                        <small className="text-danger">{t.forms.invalid_input}</small>
                                                    </Form.Control.Feedback>
                                                </FloatingLabel>
                                                    : ""
                                            }
                                            {
                                                f.field_type === 'singular' ||  f.field_type === "multiple"?
                                                    <>
                                                        <Select
                                                            options={f.choices?.map((c)=>{return({ value: c, label: c })})}
                                                            isMulti={f.field_type === "multiple"}
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            classNamePrefix="react-select"
                                                            required={true}
                                                            components={{
                                                                Option: SelectOption,
                                                                ValueContainer: CustomSelectValueContainer
                                                            }}
                                                            className="select-form-control"
                                                            allowSelectAll={true}
                                                            styles={{
                                                                placeholder: (provided, state) => ({
                                                                    ...provided,
                                                                    position: "absolute",
                                                                    top: state.hasValue || state.selectProps.inputValue ? -15 : "15%",
                                                                    transition: "top 0.1s, font-size 0.1s",
                                                                    fontSize: (state.hasValue || state.selectProps.inputValue) && 13
                                                                })
                                                            }}
                                                            placeholder={<div>{(f.field_names[currentLang] || f.field_names.it)}</div>}
                                                            value={
                                                                f.field_type === 'singular' ?
                                                                    (userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values[0]) ? { value: userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values[0], label: userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values[0] } : ''
                                                                : userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values?.map((c)=>{return({ value: c, label: c })}) || ''
                                                            }
                                                            onChange={(e)=>dispatch(updateUserField({value: e, field_id: field_id, type:'extra', field_type:'choices'}))}
                                                        />
                                                        {!userInfo?.user_data?.extra_fields.find(e => e.field_id === field_id)?.values?.length > 0 ?
                                                            <small className="text-danger">{t.forms.invalid_select}</small>
                                                        : null}
                                                    </>
                                                : ""
                                            }
                                        </Form.Group>
                                    )
                                } else return null
                            })
                        }

                        <div className="bottom_controller">
                            <Button className="mx-auto w-100" type={'submit'} >
                                {t.self_assessment_test.confirm_proceed}
                            </Button>
                        </div>
                        </Form>
                    </div>
                : ""
            }
            {
                currentStep === 3 ?
                    <div className="px-3 pt-5 mt-5 h-100 d-flex justify-content-start align-items-center flex-column text-center ">
                        <img src={pc_img} style={{width:'60px'}}/>
                        <TitleH1 className="mt-2">{t.self_assessment_test.pc_login}</TitleH1>
                        <p>{t.self_assessment_test.pc_login_text.split('{url}').reduce((a, b) => <>{a}<strong style={{color:'var(--primary-color)'}}><i><u>{`${getRedirectUrl()}${WEB_PATH}`}</u></i></strong>{b}</>)}</p>
                        <div className="bottom_controller">
                            <p>{t.self_assessment_test.login_with} <strong style={{color:'var(--primary-color)'}}>{userInfo?.user_data?.email}</strong></p>
                            <Button className="w-100 mx-auto" onClick={copyUrl}>
                                {t.self_assessment_test.copy_link}
                            </Button>
                        </div>
                    </div>
                : ""
            }
        </div>
        
    )
}